<template>
  <div :style="{ height: isHigh ? '44px' : '0px' }"></div>
</template>

<script>
export default {
  name: 'page-header',
  data() {
    return {
      isHigh: false
    }
  },
  mounted() {
    const env = this.$globalObj.getEnvType()
    this.isHigh = env.startsWith('FLUTTER')
    // this.isHigh = true
  }
}
</script>

<style></style>